module.exports = __webpack_public_path__ + "static/img/zhuanli-4.a496b7dd.png";